import * as Msdyn365 from '@msdyn365-commerce/core';

export interface ICheckEmailVerificationTokenResponse {
    success: boolean;
    isTokenValid: boolean;
    existingUser: boolean;
}

interface ICheckEmailVerificationTokenData {
    '@odata.context': string;
    IsTokenValid: boolean;
    ExistingUser: boolean;
}

export class CheckEmailVerificationTokenInput implements Msdyn365.IActionInput {
    public email: string;
    public token: string;
    constructor(email: string, token: string) {
        this.email = email;
        this.token = token;
    }
    public getCacheKey = () => `CheckEmailVerificationTokenInput-${this.email}-${this.token}`;
    public getCacheObjectType = () => 'CheckEmailVerificationTokenInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (_args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CheckEmailVerificationTokenInput('', '');
};

async function action(
    input: CheckEmailVerificationTokenInput,
    ctx: Msdyn365.IActionContext
): Promise<ICheckEmailVerificationTokenResponse> {
    try {
        const response = await Msdyn365.sendRequest<ICheckEmailVerificationTokenData>(
            `${ctx.requestContext.apiSettings.baseUrl}Commerce/CheckEmailVerificationToken`,
            'post',
            {
                email: input.email,
                token: input.token
            },
            {
                headers: {
                    OUN: ctx.requestContext.apiSettings.oun
                }
            }
        );

        if (response.status !== 200 || !response.data) {
            return { success: false, isTokenValid: false, existingUser: false };
        }

        return {
            success: true,
            isTokenValid: response.data.IsTokenValid,
            existingUser: response.data.ExistingUser
        };
    } catch (error) {
        console.error('CheckEmailVerificationToken failed.', error);
        return { success: false, isTokenValid: false, existingUser: false };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckEmailVerificationTokenResponse>>action,
    id: 'PostCheckEmailVerificationToken',
    input: createInput
});
